import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
const { VITE_BASE_URL } = import.meta.env;
// Define your Report API slice
export const deleteAccountApi = createApi({
  reducerPath: "deleteAccountApi",
  baseQuery: fetchBaseQuery({ baseUrl: VITE_BASE_URL }),
  endpoints: (builder) => ({
    deleteAccount: builder.mutation({
      query: (data) => ({
        url: VITE_BASE_URL + "/api/v1/user/resend-otp",
        method: "POST",
        body: data,
      }),
    }),
  }),
});

export const verifyOtpApi = createApi({
  reducerPath: "verifyOtpApi",
  baseQuery: fetchBaseQuery({ baseUrl: VITE_BASE_URL }),
  endpoints: (builder) => ({
    verifyOtp: builder.mutation({
      query: (data) => ({
        url: VITE_BASE_URL + "/api/v1/user/verify-otp",
        method: "POST",
        body: data,
      }),
    }),
  }),
});


export const deleteUserApi = createApi({
  reducerPath: "deleteUserApi",
  baseQuery: fetchBaseQuery({ baseUrl: VITE_BASE_URL }),
  endpoints: (builder) => ({
    deleteUser: builder.mutation({
      query: (data) => ({
        url: VITE_BASE_URL + "/api/v1/user/delete-user-with-data",
        method: "POST",
        body: data,
      }),
    }),
  }),
});


export const { useDeleteAccountMutation } = deleteAccountApi;

export const { useVerifyOtpMutation } = verifyOtpApi;

export const {useDeleteUserMutation} = deleteUserApi;